import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontLeftUpperControlArmProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function FrontLeftUpperControlArm(props: FrontLeftUpperControlArmProps) {
  return (
    <svg
      width="68"
      height="48"
      viewBox="0 0 68 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{bottom: 86, left: 247}}
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39 40.3145C43.6604 38.6669 47 34.2246 47 29C47 27.0439 46.5323 25.197 45.7021 23.5654L65 1H55L40 18.0879C38.4237 17.3266 36.8679 17 35 17C33.2156 17 31.5221 17.3893 30 18.0879L15 1H5L23.7393 23H7C3.68633 23 1 25.6863 1 29C1 32.3137 3.68633 35 7 35H24.6094C26.029 37.4531 28.29 39.3564 31 40.3145V47H39V40.3145ZM24.0273 23.3389L24.2695 23.6221C24.2052 23.7501 24.1438 23.8801 24.084 24.0107L24.0273 23.3389Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M39.0001 41V47H31.0001V41"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="2"
        cy="2"
        r="2"
        transform="matrix(1 0 0 -1 5.00009 31)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M25.0001 35H7.00009C3.68638 35 1.00009 32.3137 1.00009 29C1.00009 25.6863 3.68638 23 7.00009 23H24.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M55.0001 1.00032L40.0001 18.0882C38.4237 17.3268 36.868 17 35.0001 17C33.2157 17 31.5222 17.3895 30.0001 18.0881L15.0001 1.00021L5.00009 1L24.2695 23.6224C23.4573 25.24 23.0001 27.0666 23.0001 29C23.0001 35.6274 28.3727 41 35.0001 41C41.6275 41 47.0001 35.6274 47.0001 29C47.0001 27.0438 46.532 25.1969 45.7017 23.5652L65.0001 1.00032H55.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M43.0001 29L39.0001 22.0718L31.0001 22.0718L27.0001 29L31.0001 35.9282L39.0001 35.9282L43.0001 29Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="4"
        cy="4"
        r="4"
        transform="matrix(1 0 0 -1 31.0001 33)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
